import React from "react";
import { useAuth } from "../context/LoginContext";
// import { jwtDecode } from "jwt-decode";
import { FcGoogle } from "react-icons/fc";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import logo from "../assets/IonTime.png";
import toplogo from "../assets/IonIdealogo.png";
import bgImg from "../assets/leftIontimeLogo.jpg";
//import { GoogleLogin } from "@react-oauth/google";

const LoginPage: React.FC = () => {
  //const { login, logout, getToken, testLogin } = useAuth();
  const { login, logout, getToken } = useAuth();
  const location = useLocation();
  const baseURL = `${window.location.origin}`;
  const navigate = useNavigate();
  //const [testUsername, setTestUsername] = React.useState(""); // State for the textbox

  // const handleTestLogin = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   if (testUsername.trim()) {
  //     testLogin(testUsername.trim()); // Calls the existing useAuth function
  //   }
  // };
  React.useEffect(() => {
    if (location.state && location.state.from) {
      localStorage.setItem("redirectPath", location.state.from.pathname);
    }
  }, [location]);

  return (
    <div className="h-screen w-screen bg-gray-400">
      {/* <GoogleLogin
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onSuccess={(credentialResponse: any) => {
          console.log("Login Success:", credentialResponse);
          // const credential = credentialResponse.credential;
          if (credentialResponse && credentialResponse?.code) {
            getToken(credentialResponse?.code, baseURL);
          }
        }}
        onError={() => {
          console.log("Login Failed:");
          logout();
        }}
        useOneTap={true}
        auto_select={true}
        ux_mode='popup'
        text='signin_with'
      /> */}

      <div
        className={`fixed grid place-items-center  top-0 right-0 left-0 z-50 w-full inset-0 h-modal h-full justify-center items-center `}
        style={{
          backgroundImage: `url(${bgImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>

        <img
          src={toplogo}
          loading="lazy"
          className="w-64 mx-auto rounded-xl bg-white shadow-xl p-8 absolute top-8 left-1/2 transform -translate-x-1/2 "
        />
        <div className="relative container m-auto px-6">
          <div className="m-auto ">
            <div className="rounded-xl bg-white shadow-xl">
              <div className="px-8 py-4 pb-8 mt-24">
                <div className="space-y-4">
                  <img src={logo} loading="lazy" className="w-40 mx-auto" />
                </div>
                <div className="mt-6 grid space-y-4">
                  <button
                    onClick={login}
                    className="group h-10 px-6 border-2 border-gray-300 rounded-full transition duration-300 hover:border-blue-400 focus:bg-blue-50 active:bg-blue-100"
                  >
                    <div className="relative flex items-center space-x-4 justify-center">
                      <FcGoogle size={24} />
                      <span className="block w-max font-semibold tracking-wide text-gray-700 text-sm transition duration-300 group-hover:text-blue-600 sm:text-base">
                        SignIn with Google
                      </span>
                    </div>
                  </button>
                  <div className="inline-flex items-center justify-center w-full my-5">
                    <hr className="w-40 h-1 my-0 bg-gray-200 border-0 rounded dark:bg-gray-700" />
                    <div className="absolute px-1 text-sm -translate-x-1/2 bg-white left-1/2 dark:bg-gray-900">
                      or
                    </div>
                  </div>
                  <button
                    className="group h-10 px-6 border-2 border-gray-300 rounded-full transition duration-300 hover:border-blue-400 focus:bg-blue-50 active:bg-blue-100"
                    onClick={() => navigate("/login-tt")}
                  >
                    SignIn to TalentTigers
                  </button>

                  {/* Test login button - only visible in development
                  {process.env.REACT_APP_ENV === "development" && (
                    <button
                      className='group h-10 px-6 border-2 border-red-300 rounded-full transition duration-300 hover:border-red-400 focus:bg-red-50 active:bg-red-100'
                      onClick={() => testLogin("sandeep.vaidya")}
                    // onClick={() => testLogin("gajendra.b")}
                    //onClick={() => testLogin("sandeep.vaidya")}
                    >
                      <span className='block w-max font-semibold tracking-wide text-red-500 text-sm'>
                        Login as Test User (Dev Only)
                      </span>
                    </button>
                  )} */}
                  {/* Test login Textbox - updated for UAT/Dev environments[cite: 6]
                  {(process.env.REACT_APP_ENV === "development" ||
                    process.env.REACT_APP_ENV === "uat") && (
                    <div className="flex flex-col space-y-2 mt-4 p-4 border-2 border-red-200 rounded-xl bg-red-50">
                      <label className="text-xs font-bold text-red-600 uppercase">
                        For Test Users
                      </label>
                      <form
                        onSubmit={handleTestLogin}
                        className="flex flex-col space-y-2"
                      >
                        <input
                          type="text"
                          placeholder=""
                          value={testUsername}
                          onChange={(e) => setTestUsername(e.target.value)}
                          className="h-10 px-4 border-2 border-gray-300 rounded-full focus:border-red-400 outline-none text-sm"
                        />
                        <button
                          type="submit"
                          disabled={!testUsername.trim()}
                          className="h-10 px-6 bg-red-500 text-white rounded-full font-semibold text-sm transition duration-300 hover:bg-red-600 active:bg-red-700 disabled:bg-gray-300"
                        >
                          Login as Test User
                        </button>
                      </form>
                    </div>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
